import { render, staticRenderFns } from "./WaypointTable.vue?vue&type=template&id=f644473e&scoped=true&"
import script from "./WaypointTable.vue?vue&type=script&lang=js&"
export * from "./WaypointTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f644473e",
  null
  
)

export default component.exports